<template>
    <div class="dot-fade-spinner" :style="{ width: size + 'px', height: size + 'px' }">
        <span class="dot" v-for="n in count" :key="n" :style="getDotStyle(n)"></span>
    </div>
</template>

<script>
export default {
    name: 'DotFadeSpinner',
    props: {
        count: {
            type: Number,
            default: 12,
        },
        size: {
            type: Number,
            default: 60,
        },
        dotSize: {
            type: Number,
            default: 8,
        },
        duration: {
            type: Number,
            default: 1.2,
        },
    },
    methods: {
        getDotStyle(i) {
            const angle = (360 / this.count) * (i - 1)
            const radius = this.size / 2 - this.dotSize / 2
            const rad = (angle * Math.PI) / 180
            const x = Math.cos(rad) * radius
            const y = Math.sin(rad) * radius

            return {
                backgroundColor: 'black',
                borderRadius: '50%',
                position: 'absolute',
                top: this.size / 2 + y - this.dotSize / 2 + 'px',
                left: this.size / 2 + x - this.dotSize / 2 + 'px',
                transformOrigin: 'center center',
                animation: `fadeDot ${this.duration}s linear infinite`,
                animationDelay: `${(this.duration / this.count) * (i - 1)}s`,
            }
        },
    },
}
</script>

<style lang="scss" scoped></style>
